import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Svg,
  G,
  Path,
  ClipPath,
  Rect,
  Defs,
  Font,
  PDFDownloadLink,
} from '@react-pdf/renderer'
import { memo, useRef } from 'react'
import { getTime, transformDate } from '../../utils/utils'
// @ts-ignore
import font from '../../assets/fonts/OpenSauceSans-Bold.ttf'
// @ts-ignore
import font1 from '../../assets/fonts/OpenSauceSans-ExtraBoldItalic.ttf'
import Button from '../General/Button'
import { AiFillPrinter } from 'react-icons/ai'

const PdfDocument: React.FC<PdfViewProps> = ({
  columns = [],
  data,
  title,
  type,
  footer_render,
  column_styles,
  downloadTitle,
}) => {
  const totalPagesRef = useRef<number>(1)

  if (data?.length === 0) {
    throw new Error('Data should have length greater than zero (0)')
  }

  Font.register({
    family: 'Open Sans',
    fonts: [
      { src: font },
      {
        src: font,
        fontWeight: 'heavy',
      },
      {
        src: font1,
        fontWeight: 200,
      },
    ],
  })

  // Font.register({
  //   family: 'Open Sans1',
  //   fonts: [
  //     {src: font1},
  //     { src: font1, fontStyle: 'oblique', fontWeight: 'heavy' }
  //   ],
  // })

  const styles = StyleSheet.create({
    fontOsWald: {
      fontFamily: 'Oswald',
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 6,
      alignItems: 'flex-start',
    },
    logoStyle: {
      position: 'absolute',
      left: '15%',
      marginTop: '30%',
    },
    bodyStyle: {
      // padding: 70,
      // width: '100%'
    },
    wakuTittle: {
      textTransform: 'uppercase',
      fontSize: 10,
      color: 'black',
      // fontFamily: 'italic'
    },
    wakuCornerLeft: {
      textTransform: 'uppercase',
      fontSize: 10,
      color: 'black',
      fontFamily: 'Roboto',
    },
    headerContainer: {
      padding: 80,
    },
    tittleStyle: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: '1%',
      marginTop: '-7%',
    },
    line: {
      backgroundColor: '#1c3258',
      borderWidth: 2,
      position: 'relative',
    },
    column: {
      paddingHorizontal: 80,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: '1%',
    },
    columnText: {
      fontSize: 10,
      textTransform: 'uppercase',
      textAlign: 'center',
    },
    rowText: {
      fontSize: 10,
      // marginTop: 10,
      textAlign: 'center',
    },
    boldText: {
      fontFamily: 'Open Sans',
      fontWeight: 'heavy',
    },
    footer: {
      position: 'absolute',
      bottom: 50,
      right: 80,
      left: 80,
    },
    footerSub: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 4,
    },
    totalFooter: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    footerBottom: {
      display: 'flex',
      // flexDirection: 'co',
      alignItems: 'center',
      marginTop: 40,
    },
    // fontOblique: {
    //   fontFamily: 'Open Sans1',
    //   fontStyle: 'oblique',
    //   fontWeight: 'heavy'
    // },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
    subColumn: {
      width: 500,
      // display: 'flex',
      // alignItems: 'flex-start'
    },
    footerSubLeft: {
      display: 'flex',
      width: '100%',
      alignItems: 'flex-start',
    },
    footerSubRight: {
      display: 'flex',
      width: '100%',
      alignItems: 'flex-end',
    },
    // oswaldStyle: {
    //   fontFamily: 'Oswald'
    // }
  })

  const NevulaLogo = () => (
    <Svg>
      <G transform="scale(10)">
        <Path
          d="M21.3305 10.5337C22.4804 17.3203 27.2595 22.6709 33.3321 23.9704C33.4902 24.0025 33.6483 24.0346 33.8136 24.0667C34.2232 24.1389 34.64 24.2191 35.0425 24.3475C39.5269 25.7674 42.8183 30.38 42.8183 35.8429C42.8183 42.445 38.0249 47.7876 32.1176 47.7876C26.8139 47.7876 22.4085 43.4878 21.5605 37.8323C21.5533 37.7762 21.5461 37.72 21.539 37.6559C20.4897 30.5404 15.4591 24.917 9.08465 23.7458C9.03434 23.7378 8.98404 23.7298 8.92655 23.7218C3.73785 22.7511 -0.186007 17.609 0.0152164 11.4883C0.21644 5.17505 4.91645 0.0730967 10.5866 0.000899248C15.0495 -0.0552543 18.8871 2.93693 20.54 7.22866C20.8203 7.95866 20.8706 8.19932 20.9856 8.75283L21.3305 10.5337Z"
          fill="#c8fe01"
          fillOpacity={0.3}
        />

        <Path
          d="M6.61882 33.0271C10.2696 33.0271 13.2376 36.3321 13.2376 40.4153C13.2376 44.4904 10.2768 47.7955 6.61882 47.7955C2.96805 47.7955 0 44.4904 0 40.4153C0 36.3321 2.96086 33.0271 6.61882 33.0271Z"
          fill="#c8fe01"
          fillOpacity={0.3}
        />

        <Path
          d="M36.1989 14.7773C39.8544 14.7773 42.8177 11.4694 42.8177 7.38906C42.8177 3.30867 39.8544 0.000854492 36.1989 0.000854492C32.5434 0.000854492 29.5801 3.30867 29.5801 7.38906C29.5801 11.4694 32.5434 14.7773 36.1989 14.7773Z"
          fill="#c8fe01"
          fillOpacity={0.3}
        />

        <Path
          d="M6.61882 33.0271C10.2696 33.0271 13.2376 36.3321 13.2376 40.4153C13.2376 44.4904 10.2768 47.7955 6.61882 47.7955C2.96805 47.7955 0 44.4904 0 40.4153C0 36.3321 2.96086 33.0271 6.61882 33.0271Z"
          fill="#c8fe01"
          fillOpacity={0.3}
        />

        <Path
          d="M36.1989 14.7773C39.8544 14.7773 42.8177 11.4694 42.8177 7.38906C42.8177 3.30867 39.8544 0.000854492 36.1989 0.000854492C32.5434 0.000854492 29.5801 3.30867 29.5801 7.38906C29.5801 11.4694 32.5434 14.7773 36.1989 14.7773Z"
          fill="#c8fe01"
          fillOpacity={0.3}
        />
      </G>
      <Defs>
        <ClipPath id="clip0">
          <Rect width="500" height="500" fill="white" x={0} y={0} />
        </ClipPath>
      </Defs>
    </Svg>
  )

  const renderFooter = () => {
    if (data?.length) {
      if (type === 'FREE_FORM') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSub}>
                    <View style={styles.totalFooter}>
                      <Text style={{ fontSize: 9 }}>ITEMS {data.length}</Text>
                    </View>
                    <View style={styles.totalFooter}>
                      <Text
                        style={{
                          ...styles.wakuTittle,
                          fontSize: 9,
                          marginRight: 5,
                        }}
                      >
                        SUB TOTAL
                      </Text>
                      <Text style={{ ...styles.wakuTittle, fontSize: 18 }}>
                        {footer_render.sub_total}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.footerSub}>
                    <View style={styles.totalFooter}>
                      <Text style={{ fontSize: 9, marginRight: 5 }}>
                        DESCUENTO
                      </Text>
                      <Text style={{ fontSize: 13 }}>0.00</Text>
                    </View>
                    <View style={styles.totalFooter}>
                      <Text
                        style={{
                          ...styles.wakuTittle,
                          fontSize: 9,
                          marginRight: 5,
                        }}
                      >
                        IVA
                      </Text>
                      <Text style={{ ...styles.wakuTittle, fontSize: 18 }}>
                        {footer_render.iva}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.footerSub}>
                    <View style={styles.totalFooter}>
                      <Text style={{ fontSize: 12, marginRight: 5 }}>
                        Cliente
                      </Text>
                      <Text style={{ fontSize: 12 }}>
                        {footer_render.clientName}
                      </Text>
                    </View>
                    <View style={styles.totalFooter}>
                      <Text
                        style={{
                          ...styles.wakuTittle,
                          fontSize: 9,
                          marginRight: 5,
                        }}
                      >
                        EXENTO
                      </Text>
                      <Text style={{ ...styles.wakuTittle, fontSize: 18 }}>
                        {footer_render.exempt}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.footerSub}>
                    <View style={styles.totalFooter}>
                      <Text style={{ fontSize: 12 }}>RIF: </Text>
                      <Text style={{ fontSize: 12 }}>
                        {footer_render.clientDocument}
                      </Text>
                    </View>
                    <View style={styles.totalFooter}>
                      <Text
                        style={{
                          ...styles.wakuTittle,
                          fontSize: 9,
                          marginRight: 5,
                        }}
                      >
                        TOTAL
                      </Text>
                      <Text style={{ ...styles.wakuTittle, fontSize: 18 }}>
                        {footer_render.total}
                      </Text>
                    </View>
                  </View>
                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 10 }}>
                      GRACIAS POR TU COMPRA
                    </Text>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'DELIVERY_NOTE') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        TOTAL DE ORDEN
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.total}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>ITEMS {data.length}</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        PROVEEDOR:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.clientName}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>RIF: </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.clientDocument}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'ADJUSTMENT') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        TOTAL DE OPERACIÓN
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.total}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>ITEMS {data.length}</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.warehouse}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'CARGO') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        TOTAL DE OPERACIÓN
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.total}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>ITEMS {data.length}</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>{footer_render.to}</Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'DESCARGO') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        TOTAL DE OPERACIÓN
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.total}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>ITEMS {data.length}</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>{footer_render.from}</Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'TRANSFERENCIA') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        TOTAL DE OPERACIÓN
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.total}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>ITEMS {data.length}</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN ORIGEN:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>{footer_render.from}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN DESTINO:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>{footer_render.to}</Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'REQUISITION') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN ORIGEN:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.origin}
                      </Text>
                    </View>
                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN DESTINO:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.destination}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>{data.length} ITEMS</Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>
                        {footer_render.status}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'INVENTORY') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.warehouse}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>{data.length} ITEMS</Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'PURCHASE') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>{data.length} ITEMS</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        PROVEEDOR:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.provider}
                      </Text>
                    </View>
                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>RIF: </Text>
                      <Text style={{ fontSize: 13 }}>{footer_render.rif}</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        ALMACÉN:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.warehouse}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'PURCHASE_ORDER') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        TOTAL DE ORDEN
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.total}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>{data.length} ITEMS</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        PROVEEDOR:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.provider}
                      </Text>
                    </View>
                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>RIF: </Text>
                      <Text style={{ fontSize: 13 }}>{footer_render.rif}</Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'DELIVERY_NOTE_PURCHASE') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        TOTAL DE ORDEN
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.total}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>{data.length} ITEMS</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        PROVEEDOR:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.provider}
                      </Text>
                    </View>
                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>RIF: </Text>
                      <Text style={{ fontSize: 13 }}>{footer_render.rif}</Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }

      if (type === 'BUDGET') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={styles.footerSubRight}>
                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        NOTAS:
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.notes}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        TOTAL DE ORDEN
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.total}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 9 }}>{data.length} ITEMS</Text>
                    </View>

                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>
                        CLIENTE:{' '}
                      </Text>
                      <Text style={{ fontSize: 13 }}>
                        {footer_render.provider}
                      </Text>
                    </View>
                    <View
                      style={{
                        ...styles.totalFooter,
                        marginBottom: 5,
                        alignItems: 'center',
                      }}
                    >
                      <Text style={{ fontSize: 9, marginRight: 3 }}>RIF: </Text>
                      <Text style={{ fontSize: 13 }}>{footer_render.rif}</Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      } if (type === 'ARQUEO') {
        return (
          <View
            style={styles.footer}
            render={({ pageNumber }) =>
              pageNumber === totalPagesRef.current && (
                <View>
                  <View style={{alignItems: 'center'}}> 
                    <View style={{ ...styles.totalFooter, marginBottom: 5, alignItems: 'center' }}>
                      <Text style={{ fontSize: 12, marginRight: 3 }}>
                        TOTAL ENTREGADO
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 12, marginRight: 3 }}>
                        {footer_render.totalDelivered}
                      </Text>
                    </View>

                    <View style={{ ...styles.totalFooter, marginBottom: 5 }}>
                      <Text style={{ fontSize: 12 }}>{footer_render.totalDeliveredDolar}</Text>
                    </View>
                  </View>

                  <View style={styles.footerBottom}>
                    <Text style={{ fontSize: 13, marginBottom: 4 }}>
                      Impreso por wilmerreyes
                    </Text>
                    <Text style={{ fontSize: 13 }}>
                      {transformDate(new Date().toISOString())} -{' '}
                      {getTime(new Date().toISOString(), true)}
                    </Text>
                  </View>
                </View>
              )
            }
          />
        )
      }
    }
  }

  return (
    <Document title={downloadTitle}>
      <Page size="A4">
        <View fixed>
          <View style={styles.logoStyle} fixed>
            <NevulaLogo />
          </View>
          <View style={styles.headerContainer} fixed>
            <View style={styles.header}>
              <Text style={{ ...styles.boldText, fontSize: 15 }}>
                WAKU CASA DE SOFTWARE
              </Text>
              <Text style={{ ...styles.boldText, fontSize: 11 }}>
                {transformDate(new Date().toISOString())}
              </Text>
            </View>

            <View style={styles.header}>
              <Text style={{ ...styles.wakuTittle, fontSize: 11 }}>
                RIF J-40124576945
              </Text>
              <Text style={{ ...styles.boldText, fontSize: 11 }}>
                {getTime(new Date().toISOString(), true)}
              </Text>
            </View>

            <View style={styles.header}>
              <Text style={styles.wakuTittle}>SECTOR TIERRA NEGRA</Text>
              <Text
                style={styles.wakuTittle}
                render={({ pageNumber, totalPages }) => {
                  totalPagesRef.current = totalPages
                  return `Pag ${pageNumber} - ${totalPages}`
                }}
              />
            </View>

            <View style={styles.header}>
              <Text style={styles.wakuTittle}>AUTORIZADO POR: ROMAYJJ</Text>
            </View>

            <View style={styles.header}>
              <Text style={styles.wakuTittle}>USUARIO WILMERREYEES</Text>
            </View>
          </View>

          <View style={styles.tittleStyle} fixed>
            <Text
              style={{
                ...styles.boldText,
                fontSize: 25,
                textTransform: 'uppercase',
              }}
            >
              {title}
            </Text>
          </View>

          <View style={styles.line} fixed></View>
        </View>

        {data && data.length && type !== 'ARQUEO' && (
          <View style={styles.column}>
            {columns.map((column, idx) => (
              <View
                key={column}
                style={{ ...styles.subColumn, ...column_styles[column] }}
              >
                <Text
                  style={{
                    ...styles.columnText,
                    fontFamily: 'Open Sans',
                    fontWeight: 200,
                    marginBottom: 10,
                  }}
                >
                  {column}
                </Text>
                {data.map((dat, index) => (
                  <Text
                    key={dat[0]}
                    break={index % 20 === 0 && index !== 0}
                    style={{ ...styles.rowText, height: 30 }}
                  >
                    {dat[idx]}
                  </Text>
                ))}
              </View>
            ))}
          </View>
        )}

        {/* { type === 'ARQUEO' && data && (
            <View style={{marginTop: 20}}>
            { columns.map((column, idx) => (
              <View>
                <View style={{display: 'flex', flexDirection: 'row'}}>
                  <View style={{padding: 7, borderTopWidth: idx % 3 !== 0 ? 0 : 1, borderBottomWidth: 1, borderRightWidth: 1, borderLeftWidth: 1, borderColor: 'black', width: 100}}>
                    <Text style={{fontSize: 10}}>{column}</Text>
                  </View>
                  <View style={{padding: 7, borderTopWidth: idx % 3 !== 0 ? 0 : 1, borderBottomWidth: 1, borderRightWidth: 1, borderColor: 'black', width: 100}}>
                    <Text style={{fontSize: 10}}>{data[idx]}</Text>
                  </View>
                </View>
              </View>
            ))}
            </View>
          )} */}

        {type === 'ARQUEO' && data && (
          <View style={{ marginTop: 20, marginLeft: 50 }}>
              {data.map((dat, idx) => (
                <View style={{ marginBottom: 15, display: 'flex', flexDirection: 'row' }}>
                  <View>
                  {dat.map((individualData, index) => (
                    <View>
                      <View style={{ display: 'flex', flexDirection: 'row' }}>
                        <View
                          style={{
                            padding: 7,
                            borderTopWidth: index % 3 !== 0 ? 0 : 0.8,
                            borderBottomWidth: 0.8,
                            borderRightWidth: 0.8,
                            borderLeftWidth: 0.8,
                            borderColor: 'black',
                            width: 100,
                          }}
                        >
                          <Text style={{ fontSize: 10 }}>
                            {columns[idx][index]}
                          </Text>
                        </View>
                        <View
                          style={{
                            padding: 7,
                            borderTopWidth: index % 3 !== 0 ? 0 : 0.8,
                            borderBottomWidth: 0.8,
                            borderRightWidth: 0.8,
                            borderColor: 'black',
                            width: 100,
                          }}
                        >
                          <Text style={{ fontSize: 10 }}>{individualData}</Text>
                        </View>
                      </View>
                    </View>
                  ))}
                  </View>
                  <View style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Text style={{marginLeft: 40, fontSize: 15}}>1.130.000 (251.111$)</Text>
                    </View>
                </View>
              ))}
          </View>
        )}

        {renderFooter()}
      </Page>
    </Document>
  )
}

const PdfView: React.FC<PdfViewProps> = (props) => {
  return (
    <PDFViewer height="100%" width="100%">
      <PdfDocument {...props} />
    </PDFViewer>
  )
}

export const NoMemoPdfButton: React.FC<PdfViewProps> = (props) => {
  return (
    <Button
      type="primary"
      classes="w-1/2 h-8 flex-1"
      htmlType="button"
      icon={<AiFillPrinter className="text-success" size="1.1rem" />}
    >
      <PDFDownloadLink
        document={<PdfDocument {...props} />}
        fileName={props.downloadTitle + '.pdf'}
      >
        {({ blob, url, loading, error }) =>
          loading ? '...' : 'Imprimir Presupuesto'
        }
      </PDFDownloadLink>
    </Button>
  )
}

const pdfButton: React.FC<PdfViewProps> = (props) => {
  return (
    <PDFDownloadLink
      document={<PdfDocument {...props} />}
      fileName={props.downloadTitle + '.pdf'}
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          '...'
        ) : (
          <Button
            type="link"
            classes="text-success-600 hover:text-success-400"
            danger
            icon={<AiFillPrinter className="text-success" size="1.1rem" />}
          >
            Imprimir
          </Button>
        )
      }
    </PDFDownloadLink>
  )
}

export const PdfButton = memo(
  pdfButton,
  (prev, next) => prev.downloadTitle === next.downloadTitle
)

export default PdfView

export interface PdfViewProps {
  columns?: string[] | string[][]
  data?: string[][]
  title: string
  type:
    | 'FREE_FORM'
    | 'DELIVERY_NOTE'
    | 'ADJUSTMENT'
    | 'CARGO'
    | 'DESCARGO'
    | 'TRANSFERENCIA'
    | 'REQUISITION'
    | 'PURCHASE_ORDER'
    | 'DELIVERY_NOTE_PURCHASE'
    | 'BUDGET'
    | 'INVENTORY'
    | 'PURCHASE'
    | 'ARQUEO'
  footer_render: any
  column_styles?: any
  downloadTitle: string
}
